import styled from "styled-components";

import { theme, size } from "../../../../helpers/theme"

export const Root = styled.div`
 display: flex;
 align-items: center;
 //min-width:276px; //when we have two bottons in this section
 min-width:138px;
 position:relative;
 flex-direction: row-reverse;
 @media (max-width: ${size.laptop}) {
      display:none;
   }`;

export const ButtonLog = styled.button`
padding: 12px 24px;
border: none;
background: ${theme.colors.gray04_background};
width: 138px;
hight: 48px;

&:hover {
   //border: 1px solid ${theme.colors.blue01_active};
   //border-radius: 8px;
   color: ${theme.colors.blue01_active};
   
   & span {
   color: ${theme.colors.blue01_active};
 }
} 
`;
export const ButtonLogCreateAccount = styled.button`
padding: 12px 24px;
border: 1px solid black;
border-radius: 8px;
background: ${theme.colors.gray04_background};
width: 138px;
hight: 48px;

&:hover {
   border: 1px solid ${theme.colors.blue01_active};
   border-radius: 8px;
   
   & span {
   color: ${theme.colors.blue01_active};
 }
} 
`;


export const Text = styled.span`{
   font-family: ${theme.fonts.interRegular};
   font-style: normal;
   font-weight: ${theme.fontWeight.normal};
   color: ${theme.colors.gray01_secondaryText};
   font-size: 16px;
   line-height: 24px;
   white-space: nowrap;

     &:hover {
      color: ${theme.colors.blue01_active};
      font-family: '${theme.fonts.interRegular}';
   }
} `;


